import { getToken } from "../authorization/auth";
import { API_ENDPOINT } from "../authorization/const";

export async function getGstJson(date) {
    const res = await fetch(API_ENDPOINT + "transaction/gst/" + getToken() + "?month=" + date);
    if (res.status === 200)
        return await res.json();
    throw await res.json();
}
